<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M5.75736 5.75738C6.05025 5.46449 6.05025 4.98962 5.75736 4.69672C5.46447 4.40383 4.98959 4.40383 4.6967 4.69672L5.75736 5.75738ZM7.87868 7.8787C8.17158 7.58581 8.17158 7.11094 7.87868 6.81804C7.58579 6.52515 7.11091 6.52515 6.81802 6.81804L7.87868 7.8787ZM6.81802 13.182C7.11091 13.4749 7.58579 13.4749 7.87868 13.182C8.17158 12.8891 8.17158 12.4142 7.87868 12.1213L6.81802 13.182ZM12.1213 12.1213C11.8284 12.4142 11.8284 12.8891 12.1213 13.182C12.4142 13.4749 12.8891 13.4749 13.1819 13.182L12.1213 12.1213ZM13.1819 6.81804C12.8891 6.52515 12.4142 6.52515 12.1213 6.81804C11.8284 7.11094 11.8284 7.58581 12.1213 7.8787L13.1819 6.81804ZM4.6967 15.3034C4.98959 15.5962 5.46447 15.5962 5.75736 15.3034C6.05025 15.0104 6.05025 14.5356 5.75736 14.2426L4.6967 15.3034ZM14.2427 14.2426C13.9497 14.5356 13.9497 15.0104 14.2427 15.3034C14.5356 15.5962 15.0104 15.5962 15.3033 15.3034L14.2427 14.2426ZM15.3033 4.69672C15.0104 4.40383 14.5356 4.40383 14.2427 4.69672C13.9497 4.98962 13.9497 5.46449 14.2427 5.75738L15.3033 4.69672ZM4 10C4 8.34296 4.67076 6.84399 5.75736 5.75738L4.6967 4.69672C3.34028 6.05313 2.5 7.92916 2.5 10H4ZM7 10C7 9.17135 7.33496 8.42242 7.87868 7.8787L6.81802 6.81804C6.0045 7.63156 5.5 8.75758 5.5 10H7ZM7.87868 12.1213C7.33496 11.5777 7 10.8286 7 10H5.5C5.5 11.2425 6.0045 12.3685 6.81802 13.182L7.87868 12.1213ZM13 10C13 10.8286 12.665 11.5777 12.1213 12.1213L13.1819 13.182C13.9955 12.3685 14.5 11.2425 14.5 10H13ZM12.1213 7.8787C12.665 8.42242 13 9.17135 13 10H14.5C14.5 8.75758 13.9955 7.63156 13.1819 6.81804L12.1213 7.8787ZM5.75736 14.2426C4.67076 13.156 4 11.6571 4 10H2.5C2.5 12.0709 3.34028 13.9469 4.6967 15.3034L5.75736 14.2426ZM16 10C16 11.6571 15.3293 13.156 14.2427 14.2426L15.3033 15.3034C16.6597 13.9469 17.5 12.0709 17.5 10H16ZM14.2427 5.75738C15.3293 6.84399 16 8.34296 16 10H17.5C17.5 7.92916 16.6597 6.05313 15.3033 4.69672L14.2427 5.75738ZM10 10V11.5C10.8285 11.5 11.5 10.8285 11.5 10H10ZM10 10H8.5C8.5 10.8285 9.17155 11.5 10 11.5V10ZM10 10V8.50003C9.17155 8.50003 8.5 9.17158 8.5 10H10ZM10 10H11.5C11.5 9.17158 10.8285 8.50003 10 8.50003V10Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'UpdatingReportIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

    <style scoped></style>
